module.exports = __webpack_public_path__ + "media/images/bg/skip-button-f98d17a3f013f4f23f6d885307e9811e.png";